import { Activity, EnhancedActivity } from './Activity'
import { Location } from './Location'

export enum ModalType {
  REGION_NOTE = 'regionNote',
  REGION_REPORT = 'regionReport',
  OPERATION_NOT_ALLOWED = 'operationNotAllowed',
  SCOUTING_FORM = 'scoutingForm',
  ENHANCED_SCOUTING_FORM = 'enhancedScoutingForm',
  PAYWALL = 'paywall',
  SILAGE = 'silage',
}

export enum ModalMode {
  NONE = 'none',
  ADD_REGION = 'addRegion',
  EDIT_REGION = 'editRegion',
  ADD_NOTE = 'addNote',
  SHOW_NOTE = 'showNote',
  ADD_PIN = 'addPin',
  SHOW_PIN = 'showPin',
  ADD_ENHANCED_PIN = 'addEnhancedPin',
  SHOW_ENHANCED_PIN = 'showEnhancedPin',
  PAYWALL_SCOUTING = 'paywallScouting',
  PAYWALL_FIELD_NOTES = 'paywallFieldNotes',
  PAYWALL_REGION_REPORT = 'paywallRegionReport',
  PAYWALL_IMAGERY = 'paywallImagery',
  PAYWALL_FIELD_HEALTH = 'paywallFieldHealth',
  PAYWALL_SPLIT_VIEW = 'paywallSplitView',
  SHOW_SILAGE_FORMULAS = 'showSilageFormulas'
}

export enum ModalSize {
  S = 'S',
  M = 'M',
  L = 'L',
}

export type ModalMeta = {
  type?: ModalType;
  size?: ModalSize;
  mode: ModalMode;
  // This will most likely be extracted to a generic in the future, as meta data will depend on the modal type.
  activity?: Activity | EnhancedActivity | null;
  region?: Location;
  lng?: number;
  lat?: number;
  edit?: boolean;
}
